import(/* webpackMode: "eager" */ "/app/hub/src/app/[accountId]/folder/[folderId]/error.tsx");
